/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

/**
 * Computes the common props for the CircularOptionPicker.
 * @param asButtons
 * @param loop
 * @param ariaLabel
 * @param ariaLabelledby
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getComputeCircularOptionPickerCommonProps(
	asButtons?: boolean,
	loop?: boolean,
	ariaLabel?: string,
	ariaLabelledby?: string
) {
	const metaProps = asButtons
		? { asButtons: true }
		: { asButtons: false, loop };

	const labelProps = {
		'aria-labelledby': ariaLabelledby,
		'aria-label': ariaLabelledby
			? undefined
			: ariaLabel ||
			  _x( 'Custom color picker', 'text', 'nelio-ab-testing' ),
	};

	return { metaProps, labelProps };
}
